import { useGetNewOpenMarketProductQuery } from '../api/product/queries/useGetNewOpenMarketProduct.query';
import { useGetNewProductQuery } from '../api/product/queries/useGetNewProduct.query';
import { useGetNewUsersOwnProductQuery } from '../api/product/queries/useGetNewUsersOwnProduct.query';

export const useGetNewProduct = () => {
  const { data: newProduct } = useGetNewProductQuery();
  const { data: newOpenMarketProduct } = useGetNewOpenMarketProductQuery();
  const { data: newUsersOwnProduct } = useGetNewUsersOwnProductQuery();

  return { newProduct, newOpenMarketProduct, newUsersOwnProduct };
};
